import { render, staticRenderFns } from "./videoCover.vue?vue&type=template&id=21e3cbde&scoped=true"
import script from "./videoCover.vue?vue&type=script&lang=js"
export * from "./videoCover.vue?vue&type=script&lang=js"
import style0 from "./videoCover.vue?vue&type=style&index=0&id=21e3cbde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e3cbde",
  null
  
)

export default component.exports